import type { ReactNode, FC } from 'react';
import { ThemeOptions, ThemeOverride } from '@wix/da-react-context/pkg/ThemeContext';

import s from './SimpleContentWrapper.scss';

export interface Props {
  children: ReactNode;
}

const SimpleContentWrapper: FC<Props> = ({ children }) => {
  return (
    <ThemeOverride theme={ThemeOptions.DARK}>
      <div className={s['root']}>{children}</div>
    </ThemeOverride>
  );
};

SimpleContentWrapper.displayName = 'SimpleContentWrapper';

export default SimpleContentWrapper;
